import { render } from "./Pages.vue?vue&type=template&id=bbcc10d4&ts=true"
import script from "./Pages.vue?vue&type=script&lang=ts"
export * from "./Pages.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__